import { render, staticRenderFns } from "./Barcode.vue?vue&type=template&id=dd1a7550&scoped=true&"
import script from "./Barcode.vue?vue&type=script&lang=js&"
export * from "./Barcode.vue?vue&type=script&lang=js&"
import style0 from "./Barcode.vue?vue&type=style&index=0&id=dd1a7550&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd1a7550",
  null
  
)

export default component.exports